/* // login admin  */
export default function Style(){
  return (
    <style>
      {`
        .hidden-lg-block{
  display: block !important;
}
.flex-lg-hidden{
  display: none !important;
  
}
.block-lg-hidden{
  display: none !important;
}
@media screen and (min-width:1024px) {
  .flex-lg-hidden{
    display: flex !important;
    
  }
  .block-lg-hidden{
    display: block !important;
  }
  .hidden-lg-block{
    display: none !important;
  }
}

.popover-box .renter-btn {
  background-color: white !important;
  border: 1px solid #FCBD00;
  color: #FCBD00;
  border-radius:0px


}
.popover-box .renter-btn:hover {
  color: white;
  background-color: #FCBD00 !important;
}
.popover-box .landlord-btn {
border-radius:0px;
  color: white !important;

  border: 1px solid #FCBD00;
  background-color: #FCBD00,
}
.popover-box .landlord-btn:hover {
  border: 1px solid #FCBD00;
  background-color: white !important;
  color: #FCBD00 !important;

}

#header {
  height: 105px;
  transition: all 0.5s;
  z-index: 997;
  transition: all 0.5s;
  background: #fff;
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
  padding-top: 0.8rem;
  padding-bottom: 1rem;
}

#headerchanged {
  height: 94px;
  z-index: 997;
  transition: all 1s;
  background: #fff;
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
  padding-top: 0.8rem;
  padding-bottom: 0rem;
}

#header .logo h1 {
  font-size: 28px;
  margin: 0;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #384046;
}

.scrollEffect {
  transition: max-height 0.5s ease 0s;
  will-change: transform;
  max-height: 64px;
  width: auto;
}

.logoImg {
  transition: max-height 0.5s ease 0s;
  will-change: transform;
  max-height: 81pxpx;
  width: auto;
}


#header .logo img {
  max-height: 81px;
}

.p-6 {
  padding: 6px;
}

.me-lg-6 {
  padding-right: 37px;
}

/*--------------------------------------------------------------
# Header Social Links
--------------------------------------------------------------*/
.header-social-links {
  margin: 0 0 0 30px;
}

.header-social-links a {
  color: #9ba6af;
  padding-left: 8px;
  display: inline-block;
  line-height: 0px;
  transition: 0.3s;
}

.header-social-links a i {
  line-height: 0;
}

.header-social-links a:hover {
  color: #3498db;
}

.navBorder{
  border-bottom: 1px solid #1C1C1C;
}

.svg-nav-color{
  fill:black;
}




@media (max-width: 768px) {
  .header-social-links {
    margin: 0 15px 0 0;
  }

  .me-lg-6 {
    padding-right: 0px;
  }

  #headerchanged {
    height: 75px;
    z-index: 997;
    transition: all 1s;
    background: #fff;
    box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
    padding-top: 0.3rem;
    padding-bottom: 0rem;
  }

  .svg-nav-color{
    fill:white;
  }
}

@media (max-width: 960px) {

  .me-lg-6 {
    padding-right: 0px;
  }
}

/* // @media (max-width: 485px) {

// #header{
//   padding-top: 4.2rem;

// }
// }

// @media (max-width:334px) {

//   #header{
//     padding-top: 4.5rem;
  
//   }
//   }
//   @media (max-width:344px) {

//     #header {
//       padding-top: 4.7rem;
//       height: 165px ;
//     }
     
//   } */



/*--------------------------------------------------------------
# Navigation Menu
--------------------------------------------------------------*/
/**
* Desktop Navigation 
*/
.navbar {
  padding: 20px;
  padding-right:0px;
  box-shadow: none;
  display: flex;

}

.linkSize {
  font-family: Josefin Sans !important;
  font-size: 18px !important;
}

@media screen and (max-width: 1534px) and (min-width: 1024px) {
  .linkSize {
    font-size: 16px !important;
  }
}

.navbar ul {
  margin: 0;
  padding: 0;
  display: flex;
  list-style: none;
  align-items: center;
}

.navbar li {
  position: relative;
}

.nav-link:focus {
  color: #946F00 !important;
}
.navbar a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0 4px 0px;
  font-family: "Poppins", sans-serif;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 1.8px;
  font-weight: 400 !important;
  color: black;
  white-space: nowrap;
  transition: 0.3s;
}

.navbar a i {
  font-size: 12px;
  line-height: 0;
  margin-left: 5px;
}

.navbar a:hover,
.navbar .active,
.navbar li:hover>a {
  color: #946F00;
  text-decoration: none !important;
}

.navbar .dropdown ul {
  display: block;
  position: absolute;
  left: 14px;
  top: calc(100% + 30px);
  margin: 0;
  padding: 10px 0;
  z-index: 99;
  opacity: 0;
  visibility: hidden;
  background: #fff;
  box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);
  transition: 0.3s;
}

.navbar .dropdown ul li {
  min-width: 200px;
}

.navbar .dropdown ul a {
  padding: 3px 20px;
  font-size: 14px;
  font-weight: 400;
  color: #21262a;
}

.navbar .dropdown ul a i {
  font-size: 12px;
}

.navbar .dropdown ul a:hover,
.navbar .dropdown ul .active:hover,
.navbar .dropdown ul li:hover>a {
  color: #946F00;
  text-decoration: none;

}

a:hover,
a:active,
a:focus {
  text-decoration: none !important;
  color: #946F00;

}

.navbar .dropdown:hover>ul {
  opacity: 1;
  top: 100%;
  visibility: visible;
}

.navbar .dropdown .dropdown ul {
  top: 0;
  left: calc(100% - 30px);
  visibility: hidden;
}

.navbar .dropdown .dropdown:hover>ul {
  opacity: 1;
  top: 0;
  left: 100%;
  visibility: visible;
}



/**
* Mobile Navigation 
*/
.mobile-nav-toggle {
  color: #384046;
  font-size: 28px;
  cursor: pointer;
  display: none;
  line-height: 0;
  transition: 0.5s;
}

.mobile-nav-toggle.bi-x {
  color: #fff;
}



.navbar-mobile {
  position: fixed;
  overflow: hidden;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  /* // background: rgba(33, 38, 42, 0.9); */
  background: #000000;
  transition: 0.3s;
  z-index: 999;
}

.navbar-mobile .mobile-nav-toggle {
  position: absolute;
  top: 67px;
  right: 15px;
}

.navbar-mobile ul {
  display: block;
  position: absolute;
  top: 55px;
  right: 15px;
  bottom: 15px;
  left: 15px;
  padding: 10px 0;
  background-color: #000000 transparent;
  overflow-y: auto;
  transition: 0.3s;
}

.navbar-mobile a {
  padding: 10px 30px;
  font-size: 22px !important;
  color: #fff;
  border-bottom: 1px solid rgb(181, 181, 181);
}

.navbar-mobile a:hover,
.navbar-mobile .active,
.navbar-mobile li:hover>a {
  padding-left: 30px !important;
  padding-right: 30px !important;
  color: #946F00;
}

.navbar-mobile .getstarted {
  margin: 15px;
}

.disButton {
  padding: 8px 30px !important;
  font-family: "Josfin Sans" !important;
  font-size: 16px !important;
  color: #a4a4a4 !important;
  border-bottom: 1px solid rgb(181, 181, 181);

}

.searchBox {
  border-bottom: 1px solid rgb(181, 181, 181);

}

.searchB {
  position: absolute !important;
  top: 37% !important;
  left: 42%;
  right: 9.5% !important;
}

.navbar-mobile .dropdown ul {
  position: static;
  display: none;
  margin: 10px 20px;
  padding: 10px 0;
  z-index: 999;
  opacity: 1;
  visibility: visible;
  background: none;
  box-shadow: none;
}

.navbar-mobile .dropdown ul li {
  min-width: 200px;
}

.navbar-mobile .dropdown ul a {
  color: white;
  padding: 10px 20px;
}

.navbar-mobile .dropdown ul a i {
  font-size: 12px;
}

.navbar-mobile .dropdown ul a:hover,
.navbar-mobile .dropdown ul .active:hover,
.navbar-mobile .dropdown ul li:hover>a {
  color: #946F00;
}

.navbar-mobile .dropdown>.dropdown-active {
  display: block;
}
@media Screen and (max-width: 1023px) {
  .mobile-nav-toggle {
    display: block ;

  }


  .navbar {
    padding-left: 0 !important;
    position: fixed !important;
  }

  /* .navbar ul {
    display: none;
  } */
}



@media (max-width: 1366px) {
  .navbar .dropdown .dropdown ul {
    left: -90%;
  }

  .navbar .dropdown .dropdown:hover>ul {
    left: -100%;
  }
}

       
        `}
    </style>
  );
}

